import classNames from 'classnames';
import React from 'react';
import * as styles from './PostTitleWithVerified.module.scss';
import TextWithIcon from '../../../components/TextWithIcon';
import { gql } from '../../../graphql/generated/gql';
import type { DocumentType } from '../../../graphql/generated/gql';
import getVerificationStatus, {
  VerificationStatus,
} from '../../../post/getVerificationStatus';
import VerifiedIcon from '../../../post/VerifiedIcon';

const POST_FRAGMENT = gql(`
  fragment PostTitleWithVerified_post on Post {
    id
    title
    ...getVerificationStatus_post
  }
`);

interface PostTitleWithVerifiedProps {
  post: DocumentType<typeof POST_FRAGMENT>;
  iconSize?: 'small' | 'regular';
  truncate?: 'single' | 'multi' | null;
}

const PostTitleWithVerified = ({
  post,
  iconSize = 'regular',
  truncate = null,
}: PostTitleWithVerifiedProps) => (
  <TextWithIcon
    text={post.title}
    icon={
      getVerificationStatus(post) === VerificationStatus.Verified && (
        <span className={classNames(styles.icon, styles[iconSize])}>
          <VerifiedIcon inline size={iconSize} />
        </span>
      )
    }
    truncate={truncate || undefined}
  />
);

export default PostTitleWithVerified;
